import { Platform } from "react-native";

export const IsWeb = () => Platform.OS === "web";
export const IsAndroid = () => Platform.OS === "android";
export const IsIOS = () => Platform.OS === "ios";
export const IsMobile = () => Platform.OS !== "web";
